import React, { Component } from "react";
import styles from "./trips.module.scss";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";
import { withLogisticRoutes } from "../../../shared/containers/containerLogisticRoutes";
import Scrollbars from "react-custom-scrollbars-2";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { withLogisticTripRoutes } from "../../../shared/containers/containerLogisticTripRoutes";
import { states } from "../../../reducers/queriesStates";
import { withAuth } from "../../../shared/containers/containerAuth";

class CreateTripRouteList extends Component {
  componentDidUpdate(preProps) {
    const { logisticAddTripRouteDataState, logisticDeleteTripRouteDataState, onGetLogisticTrip, logisticSelectedTrip } = this.props;

    if (
      (logisticAddTripRouteDataState === states.READY && preProps.logisticAddTripRouteDataState === states.REQUEST) ||
      (logisticDeleteTripRouteDataState === states.READY && preProps.logisticDeleteTripRouteDataState === states.REQUEST)
    ) {
      onGetLogisticTrip({ id: logisticSelectedTrip.id });
    }
  }

  onChangeHandler(isCheck, route) {
    const { onAddLogisticTripRoute, onDeleteLogisticTripRoute, logisticSelectedTrip, data } = this.props;

    const addPermission = data.permissions.includes(49001);
    const deletePermission = data.permissions.includes(49002);

    if (isCheck) {
      if (addPermission) onDeleteLogisticTripRoute(route, logisticSelectedTrip.id);
    } else {
      if (deletePermission) onAddLogisticTripRoute(route, logisticSelectedTrip.id);
    }
  }

  render() {
    const { logisticRoutes, logisticSelectedTrip } = this.props;
    const height = window.innerHeight > 800 ? 650 : 450;

    if (logisticRoutes === null || logisticRoutes.length === 0) return null;

    return (
      <div className={styles.createTripRouteList}>
        <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
          {logisticRoutes.map((route, index) => {
            const isCheck = logisticSelectedTrip.routes.some((x) => {
              return x.id === route.id;
            });

            return (
              <div
                key={route.id}
                className={styles.createTripRouteListItem}
                style={{ backgroundColor: index % 2 === 0 ? "#90c0db18" : "white" }}
              >
                <div>{route.title}</div>
                <div>{route.description}</div>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onChangeHandler(isCheck, route);
                  }}
                >
                  {isCheck ? (
                    <div className={styles.container_itemChecked}>
                      <CheckCircleIcon fontSize="small" />
                    </div>
                  ) : (
                    <div className={styles.container_itemUnchecked}>
                      <CheckCircleOutlineIcon fontSize="small" />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </Scrollbars>
      </div>
    );
  }
}

export default withAuth(withLogisticTripRoutes(withLogisticRoutes(withLogisticTrips(React.memo(CreateTripRouteList)))));
